import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Seede_logotype.svg")